export default {
  primary: "#0093FF",
  gray: {
    base: "#9e9e9e",
    lighten5: "#fafafa",
    lighten4: "#f5f5f5",
    lighten3: "#eeeeee",
    lighten2: "#e0e0e0",
    lighten1: "#bdbdbd",
    darken1: "#757575",
    darken2: "#616161",
    darken3: "#424242",
    darken4: "#212121",
  },
  blue: {
    base: "#1976D2",
    lighten5: "#E3F2FD",
  },
};
